import { AccountView } from "@daveyplate/better-auth-ui";
import { createFileRoute, useLocation } from "@tanstack/react-router";

export const Route = createFileRoute("/account/$")({
	component: AccountViewPage,
	ssr: false,
});

function AccountViewPage() {
	const pathname = useLocation({ select: (location) => location.pathname });

	return (
		<div className="container mx-auto px-4 py-8">
			<AccountView pathname={pathname} />
		</div>
	);
}
